import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header = ({ handleLoginRedirect, fadeIn }) => {
  return (
    <motion.nav
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={fadeIn}
      className="w-full bg-transparent p-4 flex justify-between items-center shadow-sm"
    >
      {/* Logo (Increased size) */}
      <div className="flex items-center">
        <img src="/assets/medpredix-logo-black.svg" alt="Logo" className="h-14 w-auto" />
      </div>

      {/* Navigation Links */}
      <ul className="flex space-x-8 text-black">
        <li>
          <Link to="/" className="hover:text-purple-600 font-semibold transition-colors duration-300">
            Home
          </Link>
        </li>
        <li>
          <Link to="/#features" className="hover:text-purple-600 font-semibold transition-colors duration-300">
            Features
          </Link>
        </li>
        <li>
          <Link to="/#accuracy" className="hover:text-purple-600 font-semibold transition-colors duration-300">
            Accuracy
          </Link>
        </li>
        <li>
          <Link to="/#contact" className="hover:text-purple-600 font-semibold transition-colors duration-300">
            Contact Us
          </Link>
        </li>
      </ul>

      {/* Login Button */}
      <div className="flex space-x-4">
        <button
          onClick={handleLoginRedirect}
          className="px-5 py-2 bg-green-600 text-white rounded-lg font-semibold transition duration-300 hover:bg-green-700"
        >
          Login
        </button>
      </div>
    </motion.nav>
  );
};

export default Header;
